import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../../notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { TeamService } from '../../../../services/Teams/team.service';
import { UserService } from '../../../../services/Users/manage-user/user.service';
import * as commonConstant from '../../../../../app/services/common.constant';
import { TeamlistComponent } from '../../reusablepages/team/teamlist/teamlist.component'
import { EventemitterService } from '../../../../services/eventemitter.service';
import { ClientService } from 'src/app/services/Client/client.service';
import { DatatransferService } from 'src/app/services/DataTransfer/datatransfer.service';
import * as CommonFunction from '../../../../../../src/app/services/common.function';
import { UserlistComponent } from '../../reusablepages/user/userlist/userlist.component';
import { ModulesService } from 'src/app/services/Authetication/menu-permission/modules.service';
import { MatSelect } from '@angular/material/select';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {  ReportTypes ,PriorityTypes,TurnaroundTimeTypes} from '../../../../models/client/addeditclient.model';

@Component({
  selector: 'app-addteams',
  templateUrl: './addteams.component.html',
  styleUrls: ['./addteams.component.css']
})
export class AddteamsComponent implements OnInit {

   @ViewChild(UserlistComponent, { static: false }) userslist!: UserlistComponent;
   @Input() teamId: string | undefined | null;
   @Input() teamMembers: any | string | undefined | null;
   @Input() UserIdForUpdateTeamHeader: string | undefined | null;
   @ViewChild('teamMemberSelect') teamMemberSelect !: ElementRef;
   @ViewChild("checkAllSelectOptions", { read: ElementRef }) checkAllSelectOptions!: ElementRef;
   @Input() inReportTypeClient: any;
   @Input() inPriorityClient: any;
   @Input() inTurnaroundTimeClient: any;
   @Input() stReportTypesClient: any;
   @Input() flgIsEmailOnPublishClient: boolean = false;
   isInputFocused: boolean = false;
   teamMembersData: any;
   isSelectedAll:boolean = false;
   selectedTeamMembers: string[] = [];
   searchTeamMember: string = '';
   filteredTeamMembers: any[] = [];
   btnDisabled = true;
   isIndeterminate = false;
   isChecked = false;
  // teamId:any;
  // UserIdForUpdateTeamHeader:any;
  //userlist:any;
  deselectedUserIds: any[]=[];

  // Multiple Invoice Email
  multipleInvoiceEmailData: string[] = [];
  multipleInvoiceEmailForm!: FormGroup;
  showInvoiceEmailMessage: string = '';
  multiInvoiceEmailFormSubmit: boolean = false;
  private invoiceEmailModalRef: any = null;

  // Multiple Report Email
  multipleReportEmailData: string[] = [];
  multipleReportEmailForm!: FormGroup;
  showReportEmailMessage: string = '';
  multiReportEmailFormSubmit: boolean = false;
  private reportEmailModalRef: any = null;

  teamForm= new FormGroup({
    teamName: new FormControl(),
    email: new FormControl(),
    teamMember: new FormControl(),
    faxnumber: new FormControl(),
    isTPARequired: new FormControl(),
    flgIsEmailOnPublish: new FormControl(),
    reportEmail: new FormControl(),
    address: new FormControl(),
    inReportType:new FormControl(),
    inPriority:new FormControl(),
    inTurnaroundTime:new FormControl(),
    stReportTypes: new FormControl(),
  });

  teamFormData: any;
  submitted = false;
  addTeamResponse: any;
  clientId: any;
  teamResponse: any = [];
  listingBodyParameter: any;
  perPageArray:any[] = [];
  totalTeam: number = 0;
  buttonname: any
  loCurrentUserData: any;
  LoggedInRole: any;
  ViewclientId: any;
  action: string | undefined | null;
  isClientAdmin = false;
  Address: string = '';
  objUserList: any;
  userByEmailResponse: any = [];
  userByEmailLength: any;
  faxnumberInvalidate: boolean = false;
  // for team listing
  listingBodyParameterTeamListing: any;
  /** control for the MatSelect filter keyword multi-selection */
  filterTeamMember: any = [];

  options :any = [];
  selectedOptions = new FormControl(this.options);
  reportTypes: { label: string, value: number }[] = ReportTypes;
  priorityTypes: { label: string, value: number }[] = PriorityTypes;
  turnaroundTimeTypes: { label: string, value: number }[] = TurnaroundTimeTypes;
  @Output() webPageToggle = new EventEmitter<boolean>();
    selectedReportTypes: string[] = [];
    optionsReportTypes :any = [];
    selectedOptionsReportTypes = new FormControl(this.optionsReportTypes);
    filteredReportTypes = [...ReportTypes];
    selectedAvailableReports: any[] = [];
/** Subject that emits when the component has been destroyed. */
protected _onDestroy = new Subject<void>();
  constructor(
    private _Router: Router,
    private renderer: Renderer2,
    private _notificationService: NotificationService,
    private _modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _fb: FormBuilder,
    private _querystring: ActivatedRoute,
    private _teamService: TeamService,
    private _userService: UserService,
    private _teamlistComponent: TeamlistComponent,
    private _eventemitterService: EventemitterService,
    private _dataService: DatatransferService,
    private _clientService: ClientService,
    private _modulesService:ModulesService,
    private cdr: ChangeDetectorRef
  ) 
  {
    this.clientId = this._querystring.snapshot.paramMap.get('clientId');
    this.listingBodyParameter = commonConstant.listingBodyParameter;
    this.listingBodyParameter.stSortColumn = 'stName';
    this.listingBodyParameter.stSortOrder = 'desc';
    this.perPageArray = commonConstant.perPageArray;
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    this.LoggedInRole = JSON.parse(localStorage.getItem('LoggedInRole') || '{}');

    // for team listing
    // Security hotfix HF-03 (FE-5): copy the shared request so other screens' values do not leak in
    this.listingBodyParameterTeamListing = { ...commonConstant.listingBodyParameterForTeam };
    this.reportTypes = ReportTypes;
    this.priorityTypes = PriorityTypes;
    this.turnaroundTimeTypes = TurnaroundTimeTypes;
   }

  ngOnInit(): void {
    document.body.classList.remove('add-user-page', 'client-page','team-list-page');
    document.body.classList.add('add-team-page');
    this.teamId = this.teamId;
    this.listingBodyParameterTeamListing.teamId = this.teamId;
    this.teamMembersData = this.teamMembers;
    this.userByEmailResponse = this.teamMembersData;
    // Initially set the filtered team members to the entire list
    this.filterTeamMember = [...this.userByEmailResponse];
    this.userByEmailLength = this.teamMembersData.length;
    this.validate();
   // this.getRoleByRoleId(); // comment on 22-07-2022
    this.getButtonName();
    this.filteredTeamMembers = this.teamMembersData = this.teamMembers;
    this.filteredTeamMembers.forEach((allTeamMembers: any) => {
      allTeamMembers.isShow = true;
    }) 

      // Watch for changes in available report types
this.selectedOptionsReportTypes.valueChanges.subscribe((selectedValues: number[]) => {
  // Filter only reports selected in Available
  this.selectedAvailableReports = ReportTypes.filter(r =>
    selectedValues.includes(r.value)
  );
  // Get the current default
  const currentDefault = this.teamForm.get('inReportType')?.value;

  const stillExists = this.selectedAvailableReports.some(r => r.value === Number(currentDefault));

  if (!stillExists) {
    this.teamForm.patchValue({ inReportType: '' });
  }
  // Keep stReportTypes in sync
  this.teamForm.patchValue({
    stReportTypes: selectedValues
  });
});
  }

  getButtonName(){
    this.LoggedInRole;

    if (this.LoggedInRole.role.name.toLowerCase() == "client admin") {
      this.isClientAdmin = true;
      this.listingBodyParameter.uiClientId = this.loCurrentUserData.clientId;
      this.ViewclientId = this.loCurrentUserData.clientId;
      this.listingBodyParameter.uiClientId = this.ViewclientId;
    }
    else {
      this.ViewclientId = this._querystring.snapshot.paramMap.get('clientId');
      this.listingBodyParameter.uiClientId = this.ViewclientId;
    }

    if(!this.ViewclientId){
      this.ViewclientId = this.loCurrentUserData.clientId;
      this.listingBodyParameter.uiClientId = this.ViewclientId;

    }
    // Security hotfix HF-03 (FE-5): never depend on what the team list wrote before
    this.listingBodyParameterTeamListing.uiClientId = this.ViewclientId;

    
    this.action = localStorage.getItem('teamAddEditAction') || '';
    // Add - 0
    if (this.action == '0') {
        this.getTeamDetails();
      this.buttonname = 'Create';
      this.teamForm.reset(); 
    }
    else {
      // Edit - 1
      this.getTeamDetails();
      this.buttonname = 'Save';
    }
  }

  trimming_fn(x:any) { 
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  };

  toggleOption(teamMemberId: number) {
    const index = this.selectedTeamMembers.indexOf(teamMemberId.toString());
    if (index >= 0) {
      // If the member is already selected, deselect it
      this.selectedTeamMembers.splice(index, 1);
    } else {
      // If not selected, add it to the selection list
      this.selectedTeamMembers.push(teamMemberId.toString());
    }
    this.teamForm.get('teamMember')?.setValue(this.selectedTeamMembers == null ? [] : this.selectedTeamMembers);
  }

  filterTeamMemberInfo(event: any) {
    const searchValue = event.target.value.toLowerCase();
    this.filteredTeamMembers = this.teamMembers.map((teamMember: any) => ({
      ...teamMember, // Clone the object
      isShow: teamMember.teamMemberName.toLowerCase().includes(searchValue)
    }));
  }

    get Reportgetter() {
    return this.teamForm.controls;
  }


  openDropdown(select: MatSelect) {
    select.open();
  }
  
  getRoleByRoleId() {
    this.spinner.show();
    this._modulesService.getRoleByRoleId(this.loCurrentUserData.roleId).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              if (response.data.role.name.toLowerCase() == "client admin") {
                this.isClientAdmin = true;
                this.listingBodyParameter.uiClientId = this.loCurrentUserData.clientId;
                this.listingBodyParameterTeamListing.uiClientId = this.loCurrentUserData.clientId;
                this.ViewclientId = this.loCurrentUserData.clientId;
                this.listingBodyParameter.uiClientId = this.ViewclientId;
              }
              else {
                this.listingBodyParameterTeamListing.uiClientId = this._querystring.snapshot.paramMap.get('clientId');
                this.ViewclientId = this._querystring.snapshot.paramMap.get('clientId');
                this.listingBodyParameter.uiClientId = this.ViewclientId;
              }
  
              if(!this.ViewclientId){
                this.ViewclientId = this.loCurrentUserData.clientId;
                this.listingBodyParameter.uiClientId = this.ViewclientId;
                // Security hotfix HF-03 (FE-5): fall back to the user's own client
                this.listingBodyParameterTeamListing.uiClientId = this.ViewclientId;
              }
  
              //this.getProducts();
              this.action = localStorage.getItem('teamAddEditAction');
              // Add - 0
              if (this.action == '0') {
                this.buttonname = 'Create';
                this.teamForm.reset();
              }
              else {
                // Edit - 1
                this.buttonname = 'Save';
  
              }
            }
          }
        }, 
        error: (error) => {
          this.spinner.hide();
          if (error != undefined) {
           this.action = localStorage.getItem('teamAddEditAction') || '';
            if (error.status == 401) {
               if (this.action == '0') {
               this.buttonname = 'Create';}
              else
              {this.buttonname = 'Save';}
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            }            
          }
        }
      }
      );
  }

  //set updated user data in userlist
  getUsers() {  
  this.spinner.show();
  this.listingBodyParameter.TimeZone = CommonFunction.GetTimeZone();
  this._userService.getUsers(this.listingBodyParameter).subscribe(
    {
      next: (response) => {
        if (!!response) {
          if (response.statusCode == 200) {
            this.spinner.hide();
            this.objUserList = response.data.resultSet;
            this._userService.sendUpdate(this.objUserList);
            this._dataService.sendDataBetweenComponentsForUserListing(response.data.resultSet);
          }
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.objUserList = {
          resultSet: []
        };
      }
    }
  );
  }

  validate() {
  this.teamForm = this._fb.group({
    teamName: ['', [Validators.required]],
    email: ['', [Validators.pattern(commonConstant.emailregex)]],
    isTPARequired :[''],
    flgIsEmailOnPublish: [false],
    faxnumber:['', [Validators.pattern(commonConstant.faxnumberregex)]],
    teamMember: [''],
    reportEmail: ['', [Validators.pattern(commonConstant.emailregex)]],
    address: [''],
    inReportType:['',[Validators.required]],
    inPriority:['', [Validators.required]],
    inTurnaroundTime:['', [Validators.required]],
    stReportTypes: [[],Validators.required],
  });

  this.multipleInvoiceEmailForm = this._fb.group({
    email: ['', [Validators.required, Validators.maxLength(32), Validators.pattern(commonConstant.emailregex)]]
  });

  this.multipleReportEmailForm = this._fb.group({
    email: ['', [Validators.required, Validators.maxLength(32), Validators.pattern(commonConstant.emailregex)]]
  });

  // Remove single-email pattern restriction — the field now shows comma-separated
  // emails managed by the popup; each individual email is validated inside the popup.
  this.teamForm.get('email')?.clearValidators();
  this.teamForm.get('email')?.updateValueAndValidity();
  this.teamForm.get('reportEmail')?.clearValidators();
  this.teamForm.get('reportEmail')?.updateValueAndValidity();
  }

  SpaceRestiction(e:any) {
    if (e.which === 32 && !e.target.value.length) {
      e.preventDefault();
      // invalid character, prevent input
    }
  }

  keyPress(event: any) {
    if (event.keyCode === 13 || event.which === 32) {
      event.preventDefault();
    }
  }

  // Convenience for easy access to form fields
  get Teamgetter() {
    return this.teamForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    // Return if form in invalid
    if (this.teamForm.invalid) {
      return;
    }
    this.teamFormData = this.teamForm.value;
    let teamName = this.teamForm.value.teamName;
    let email = this.teamForm.value.email;
    let teamMembers = this.teamForm.value.teamMember != null ? this.teamForm.value.teamMember.toString() :'';
    let TPA = this.teamForm.value.isTPARequired;
    let flgIsEmailOnPublish = this.teamForm.value.flgIsEmailOnPublish ?? false;
    let faxnumber = this.teamForm.value.faxnumber;
    let reportEmail = this.teamForm.value.reportEmail;
    let address = this.teamForm.value.address;
    let inReportType = this.teamForm.value.inReportType;
    let stReportTypes = this.teamForm.value.stReportTypes != null ? this.teamForm.value.stReportTypes.toString() : '';
    let inPriority = this.teamForm.value.inPriority;
    let inTurnaroundTime = this.teamForm.value.inTurnaroundTime;
    this.add(teamName, email, teamMembers,TPA,flgIsEmailOnPublish,faxnumber,reportEmail, address,inReportType,inPriority,inTurnaroundTime,stReportTypes);
  }

  // Common method to get a form control
  getControl(controlName: string) {
    return this.teamForm.get(controlName);
  }

  // Common blur handler
  onBlurControl(controlName: string) {
    const control = this.getControl(controlName);
    if (control && !control.value) {
      control.markAsUntouched(); // Optionally mark it untouched to reset visual state
    }
  }

  add(teamName: any, email: any, teamMembers: any,TPA:any,flgIsEmailOnPublish:any,faxnumber:any, reportEmail:any,address:any,inReportType:any,inPriority:any,inTurnaroundTime:any, stReportTypes:any) {
    this.spinner.show();   
    if(this.ViewclientId == undefined){
      this.ViewclientId = this.loCurrentUserData.clientId;
    }

    let tId = this.teamId;

    if (tId != null && tId != undefined) {
      tId = this.teamId;
    }
    else {
      tId = null;
    }

      let dt = {
        clientId: this.ViewclientId,//this.clientId,
        name: teamName.trim(),
        email: email,
        teamId: tId,
        TPA: TPA == true ? true : false,
        flgIsEmailOnPublish: flgIsEmailOnPublish == true ? true : false,
        faxnumber :faxnumber,
        teamMember: teamMembers,
        reportEmail: reportEmail,
        address:address,
        inReportType:inReportType,
        inPriority:inPriority,
        inTurnaroundTime:inTurnaroundTime,
        stReportTypes:stReportTypes,
      };
      this._teamService.addTeam(dt).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                if(this.selectedTeamMembers.length > 0){
                  this.addTeamMember(response.data);
                }
                this._notificationService.showSuccess(response.message, 'Success'); // unknown error   
                localStorage.removeItem('teamAddEditAction');
                this.hideModal();
                if (this.isClientAdmin) {
                  if (tId != null)
                    if (this.UserIdForUpdateTeamHeader == JSON.parse(localStorage.getItem('currentUserData') || '{}').userId)
                      this._dataService.sendDataBetweenComponentsForTeam({ "message": "addedUser", "teamName": teamName.trim(), "teamId": this.teamId });
  
                }
                // Security hotfix HF-03 (FE-5): list every team of the client, not the empty GUID
                this.listingBodyParameterTeamListing.teamId = null;
                this.getTeams();
                this.getUsers();
                this.spinner.hide();
              }
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.addTeamResponse = {
              resultSet: []
            };
             if (error != undefined) {
            if (error.status == 401 && error.statusText == "Unauthorized") {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            }
             }
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
  
            else {
              this._notificationService.showError(error.error.errorMessage, 'Error');
            }
          }
        }
        
        
      );
  }

  addTeamMember(uiTeamId: any) {  
    var uiLoggedInUserId = JSON.parse(localStorage.getItem('currentUserData') || '{}').userId;
      
      // this.spinner.show();
      this._teamService.addTeamMember(this.selectedTeamMembers.toString(), uiTeamId, uiLoggedInUserId,this.deselectedUserIds.toString()).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this.spinner.hide();
                // this._notificationService.showSuccess(response.data, 'Success'); // unknown error
                // Security hotfix HF-03 (FE-5): list every team of the client, not the empty GUID
                this.listingBodyParameterTeamListing.teamId = null;
                this.getTeams();
                // this.getUserByEmail();
                this.getUsers(); // for the updating user listing
                this.btnDisabled = true;
                // window.location.reload();

              }
            }
          },
          error: (error) => {
            this.spinner.hide();
             if (error != undefined) {
            if (error.status == 401 && error.statusText == "Unauthorized") {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            }
          }
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
            else {
              this._notificationService.showError(
                error.error.errorMessage,
                'Error'
              );
            }
          }
        }
      );
    //}
  }

  // Hide Modal
  hideModal() {
    this._modalService.dismissAll("");
  }

  reset() {
    this.teamForm.reset();
  }

  // for team lising
  getTeams() {
    this._teamService.getTeams(this.listingBodyParameterTeamListing).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsForTeamListing(response.data.resultSet);
              this.getClientDetails()
            }
          }
        },
        error: (error:any) => {
          this.teamResponse = [];
          this._dataService.sendDataBetweenComponentsForTeamListing(this.teamResponse);
          this.getClientDetails()
        }
      });
  }
 
  getTeamDetails() {
    this.spinner.show();
    this._teamService.getteamByTeamId(this.listingBodyParameterTeamListing).subscribe(
      {
        next: (response) => {
          if (!!response) {
              this.spinner.hide();
              
              if (this.teamId) {
                // Filter and select team members based on current teamId
                const currentTeamMembers = response.teamMembersListInfo
                  .filter((member: any) => member?.teamId && member.teamId.toLowerCase().includes(this.teamId?.toLowerCase()))
                  .map((member: any) => member?.userId?.toLowerCase() || '');
                
                if (currentTeamMembers.length > 0) {
                  this.selectedTeamMembers = currentTeamMembers;
                  this.teamForm.get('teamMember')?.setValue(this.selectedTeamMembers);
                } else {
                  this.teamForm.get('teamMember')?.setValue([]);
                }
                
                if (response.stReportTypes) {
                  // Always process as comma-separated string and convert to numbers
                  const parsedReportTypes = response.stReportTypes
                    .split(',')
                    .map((val: string) => val.trim())
                    .filter((val: string) => val !== '')
                    .map((val: string) => Number(val)); // Explicitly type the parameter
                  this.teamForm.get('stReportTypes')?.setValue(parsedReportTypes);
                  this.selectedOptionsReportTypes.setValue(parsedReportTypes);
                  
                  // Now the types match for filtering
                  this.selectedAvailableReports = ReportTypes.filter(r => {
                    const isIncluded = parsedReportTypes.includes(r.value);
                    return isIncluded;
                  });
                } else {
                  this.teamForm.get('stReportTypes')?.setValue([]);
                  this.selectedOptionsReportTypes.setValue([]);
                  this.selectedAvailableReports = [];
                }

              // For default report type
              const defaultReport = response.inReportType != 0 ? response.inReportType : this.inReportTypeClient;
              this.teamForm.get('inReportType')?.setValue(defaultReport);
                this.teamForm.get('teamName')?.setValue(response.name);
                this.teamForm.get('email')?.setValue(response.email);
                if (response.email) {
                  this.multipleInvoiceEmailData = response.email
                    .split(',').map((e: string) => e.trim()).filter((e: string) => e !== '');
                } else {
                  this.multipleInvoiceEmailData = [];
                }
                this.teamForm.get('faxnumber')?.setValue(response.faxNumber);
                this.teamForm.get('isTPARequired')?.setValue(response.flgTPA);
                this.teamForm.get('flgIsEmailOnPublish')?.setValue(response.flgIsEmailOnPublish ?? this.flgIsEmailOnPublishClient);
                this.teamForm.get('reportEmail')?.setValue(response.reportEmail);
                if (response.reportEmail) {
                  this.multipleReportEmailData = response.reportEmail
                    .split(',').map((e: string) => e.trim()).filter((e: string) => e !== '');
                } else {
                  this.multipleReportEmailData = [];
                }
                this.teamForm.get('address')?.setValue(response.address);
               // this.teamForm.get('inReportType')?.setValue(response.inReportType != 0 ? response.inReportType :  this.inReportTypeClient);
                // this.teamForm.get('availableReportTypes')?.setValue(response.availableReportTypes != 0 ? response.availableReportTypes :  this.selectedAvailableReports);
                this.teamForm.get('inPriority')?.setValue(response.inPriorityType != 0 ? response.inPriorityType : this.inPriorityClient);
                this.teamForm.get('inTurnaroundTime')?.setValue(response.inTurnaroundTimeType != null ? response.inTurnaroundTimeType : this.inTurnaroundTimeClient)
              } else {
                this.teamForm.reset();
                const valueExist = this.selectedAvailableReports.some(
                  (r) => r.value === this.inReportTypeClient
                );
                if (valueExist) {
                  this.teamForm.get('inReportType')?.setValue(this.inReportTypeClient);
                } else {
                  this.teamForm.get('inReportType')?.setValue('');
                }
                this.teamForm.get('stReportTypes')?.setValue(this.selectedAvailableReports);              
                this.teamForm.get('inPriority')?.setValue(this.inPriorityClient == null ? '':this.inPriorityClient);
                this.teamForm.get('inTurnaroundTime')?.setValue(this.inTurnaroundTimeClient == null ? '':this.inTurnaroundTimeClient);
                this.teamForm.get('flgIsEmailOnPublish')?.setValue(this.flgIsEmailOnPublishClient ?? false);

              }
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.totalTeam = 0;
          const valueExist = this.selectedAvailableReports.some(
            (r) => r.value === this.inReportTypeClient
          );
          if (valueExist) {
            this.teamForm.get('inReportType')?.setValue(this.inReportTypeClient);
          } else {
            this.teamForm.get('inReportType')?.setValue('');
          }
          this.teamForm.get('stReportTypes')?.setValue(this.selectedAvailableReports);
          this.teamForm.get('inPriority')?.setValue(this.inPriorityClient == null ? '':this.inPriorityClient);
          this.teamForm.get('inTurnaroundTime')?.setValue(this.inTurnaroundTimeClient == null ? '':this.inTurnaroundTimeClient);
          this.teamForm.get('flgIsEmailOnPublish')?.setValue(this.flgIsEmailOnPublishClient ?? false);

          if (error.status == 401) {
            this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            this._Router.navigate(['/login']);
          }
          else if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
    }

  getClientDetails() {
    let dt = {
      clientId: this.ViewclientId,
      stSearchText: "",
      stSortColumn: "stClient",
      stSortOrder: "",
      inOffset: 0,
      inLimit: 0
    };

    this._clientService.viewClient(dt).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsCLientViewPageCounts(response.data.resultSet[0]);
            }
          }
        },
        error: (error) => {
        }
      }
    );
  }

  onToggleChange(event: Event, formControlName: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.teamForm.get(formControlName)?.setValue(isChecked ? true : false);
  }

  isReportAvailable(reportValue: any): boolean {
    if (!this.stReportTypesClient || this.stReportTypesClient.length === 0) {
      return false;
    }
    return this.stReportTypesClient.includes(reportValue);
  }

  private applyParentModalBlur(apply: boolean) {
    const allModalWindows = document.querySelectorAll('ngb-modal-window');
    if (allModalWindows.length >= 1) {
      const parentDialog = (allModalWindows[0] as HTMLElement).querySelector('.modal-dialog') as HTMLElement;
      if (parentDialog) {
        parentDialog.style.filter = apply ? 'blur(3px)' : '';
        parentDialog.style.transition = 'filter 0.2s ease';
      }
    }
  }

  // --- Multiple Invoice Email ---

  showMultipleInvoiceEmailModal(modal: any) {
    this.multiInvoiceEmailFormSubmit = false;
    this.showInvoiceEmailMessage = '';
    this.multipleInvoiceEmailForm.reset();
    this.applyParentModalBlur(true);
    this.invoiceEmailModalRef = this._modalService.open(modal, { backdrop: 'static', keyboard: false, windowClass: 'email-popup' });
    this.invoiceEmailModalRef.result.then(
      () => { this.applyParentModalBlur(false); },
      () => { this.applyParentModalBlur(false); }
    );
  }

  closeInvoiceEmailModal() {
    this.multipleInvoiceEmailForm.reset();
    this.showInvoiceEmailMessage = '';
    this.multiInvoiceEmailFormSubmit = false;
  }

  checkDuplicateInvoiceEmail(value: string) {
    const primary = this.teamForm.get('email')?.value;
    const isDuplicate = this.multipleInvoiceEmailData.includes(value) || (primary && primary === value);
    this.showInvoiceEmailMessage = isDuplicate ? 'Email already added' : '';
  }

  addMultipleInvoiceEmail() {
    this.multiInvoiceEmailFormSubmit = true;
    const emailValue = this.multipleInvoiceEmailForm.get('email')?.value?.trim();
    if (!emailValue || this.multipleInvoiceEmailForm.invalid) return;
    const primary = this.teamForm.get('email')?.value;
    if (this.multipleInvoiceEmailData.includes(emailValue) || primary === emailValue) {
      this.showInvoiceEmailMessage = 'Email already added';
      return;
    }
    this.multipleInvoiceEmailData.push(emailValue);
    this.multipleInvoiceEmailForm.reset();
    this.multiInvoiceEmailFormSubmit = false;
    this.showInvoiceEmailMessage = '';
  }

  removeInvoiceEmail(index: number) {
    this.multipleInvoiceEmailData.splice(index, 1);
  }

  saveInvoiceEmails() {
    const typedEmail = this.multipleInvoiceEmailForm.get('email')?.value?.trim();
    if (typedEmail) {
      this.multiInvoiceEmailFormSubmit = true;
      if (this.multipleInvoiceEmailForm.invalid) return;
      if (this.multipleInvoiceEmailData.includes(typedEmail)) {
        this.showInvoiceEmailMessage = 'Email already added';
        return;
      }
      this.multipleInvoiceEmailData.push(typedEmail);
    } else if (this.multipleInvoiceEmailData.length === 0) {
      this.multiInvoiceEmailFormSubmit = true;
      return;
    }
    const joined = this.multipleInvoiceEmailData.join(', ');
    this.teamForm.get('email')?.setValue(joined);
    this.teamForm.get('email')?.markAsDirty();
    if (this.invoiceEmailModalRef) {
      this.invoiceEmailModalRef.dismiss();
      this.invoiceEmailModalRef = null;
    }
    this.closeInvoiceEmailModal();
  }

  // --- Multiple Report Email ---

  showMultipleReportEmailModal(modal: any) {
    this.multiReportEmailFormSubmit = false;
    this.showReportEmailMessage = '';
    this.multipleReportEmailForm.reset();
    this.applyParentModalBlur(true);
    this.reportEmailModalRef = this._modalService.open(modal, { backdrop: 'static', keyboard: false, windowClass: 'email-popup' });
    this.reportEmailModalRef.result.then(
      () => { this.applyParentModalBlur(false); },
      () => { this.applyParentModalBlur(false); }
    );
  }

  closeReportEmailModal() {
    this.multipleReportEmailForm.reset();
    this.showReportEmailMessage = '';
    this.multiReportEmailFormSubmit = false;
  }

  checkDuplicateReportEmail(value: string) {
    const primary = this.teamForm.get('reportEmail')?.value;
    const isDuplicate = this.multipleReportEmailData.includes(value) || (primary && primary === value);
    this.showReportEmailMessage = isDuplicate ? 'Email already added' : '';
  }

  addMultipleReportEmail() {
    this.multiReportEmailFormSubmit = true;
    const emailValue = this.multipleReportEmailForm.get('email')?.value?.trim();
    if (!emailValue || this.multipleReportEmailForm.invalid) return;
    const primary = this.teamForm.get('reportEmail')?.value;
    if (this.multipleReportEmailData.includes(emailValue) || primary === emailValue) {
      this.showReportEmailMessage = 'Email already added';
      return;
    }
    this.multipleReportEmailData.push(emailValue);
    this.multipleReportEmailForm.reset();
    this.multiReportEmailFormSubmit = false;
    this.showReportEmailMessage = '';
  }

  removeReportEmail(index: number) {
    this.multipleReportEmailData.splice(index, 1);
  }

  saveReportEmails() {
    const typedEmail = this.multipleReportEmailForm.get('email')?.value?.trim();
    if (typedEmail) {
      this.multiReportEmailFormSubmit = true;
      if (this.multipleReportEmailForm.invalid) return;
      if (this.multipleReportEmailData.includes(typedEmail)) {
        this.showReportEmailMessage = 'Email already added';
        return;
      }
      this.multipleReportEmailData.push(typedEmail);
    } else if (this.multipleReportEmailData.length === 0) {
      this.multiReportEmailFormSubmit = true;
      return;
    }
    const joined = this.multipleReportEmailData.join(', ');
    this.teamForm.get('reportEmail')?.setValue(joined);
    this.teamForm.get('reportEmail')?.markAsDirty();
    if (this.reportEmailModalRef) {
      this.reportEmailModalRef.dismiss();
      this.reportEmailModalRef = null;
    }
    this.closeReportEmailModal();
  }
}